module.exports = __webpack_public_path__ + "img/join.5ae4cc42.png";